import axios from 'axios';
import { getStorageData, setStorageData } from './helpers';
import { ENV } from './helpers/constants';

const SCHEMA_KEY = 'SCHEMA_KEY';
const MAX_EXPIRE_TIME = 30 * 24 * 3600 * 1000; // schemaUrl最长30天过期

const ENV_VERSION = {
  [ENV.DEV]: 'develop',
  [ENV.TEST]: 'trial',
  [ENV.RELEASE]: 'release',
};

function getSchemaOfBenefit(path, query, env) {
  return axios.request({
    url: '//benefit-center.flow.qq.com/v1/getScheme',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      path,
      query: `${query}&env=${env}`,
      envVersion: ENV_VERSION[env],
    },
  });
}

const getSchemaMap = new Map([
  ['benefit', getSchemaOfBenefit],
]);

export default class NonAdapter {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {}

  async openWechatMiniProgram(params) {
    try {
      // url schema无法生成体验版小程序的schema，所以忽略`type`参数
      const { path, appName, query, type } = params;
      const localSchemaUrl = getStorageData(`${SCHEMA_KEY}_${path}_${query}_${type}`);
      if (localSchemaUrl) {
        location.href = localSchemaUrl;
        return {
          code: 0,
          type: 'non',
        };
      }
      const { data  = {} } = await getSchemaMap.get(appName)(path, query, type);
      if (data.code !== 0) {
        return {
          msg: data.msg,
          code: data.code,
          type: 'non',
        };
      }

      setStorageData(`${SCHEMA_KEY}_${path}_${query}_${type}`, data.data.schema, {
        expiredTime: Date.now() + MAX_EXPIRE_TIME,
      });
      location.href = data.data.scheme;
      return {
        code: 0,
        type: 'non',
      };
    } catch (e) {
      return {
        msg: e.toString(),
        code: -1,
        type: 'non',
      };
    }
  }
}
